export default "__VITE_ASSET__BDak4O2i__"